import React from 'react'
import {
  TextField,
  SearchInput,
  SelectInput,
  NumberField,
  useRecordContext,
} from 'react-admin'
import { Chip } from '@mui/material'

import Datagrid from '../common/Datagrid'
import RecordSplitButton from '../common/buttons/RecordSplitButton'
import ResourceLinkField from '../common/fields/ResourceLinkField'
import List from '../common/views/List'
import DateField from '../common/fields/DateField'
import { campaignStatusChoices, sendMethodChoices, campaignStatusColors } from './constants'

const StatusField = () => {
  const record = useRecordContext()
  if (!record) return null
  return (
    <Chip
      label={record.status}
      color={campaignStatusColors[record.status] || 'default'}
      size="small"
    />
  )
}

const SendMethodField = () => {
  const record = useRecordContext()
  if (!record) return null
  return (
    <Chip
      label={record.default_send_method}
      size="small"
      variant="outlined"
    />
  )
}

const campaignFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput source="status" choices={campaignStatusChoices} alwaysOn />,
  <SelectInput source="default_send_method" label="Send Method" choices={sendMethodChoices} />,
]

const CampaignList = (props) => (
  <List
    {...props}
    filters={campaignFilters}
    exporter={false}
  >
    <Datagrid>
      <ResourceLinkField label="Name" resource="campaigns" sortBy="name">
        <TextField source="name" />
      </ResourceLinkField>
      <StatusField label="Status" source="status" />
      <SendMethodField label="Send Method" source="default_send_method" />
      <NumberField source="leads_count" label="Leads" />
      <NumberField source="sent_count" label="Sent" />
      <NumberField source="opened_count" label="Opened" />
      <DateField source="created_at" />
      <RecordSplitButton />
    </Datagrid>
  </List>
)

export default CampaignList
